import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import workSpaceCss from "../../css/workSpaceOverView.module.css";
import FSSideMenu from "../../components/consol/FSSideMenu";
import FSTopBar from "../../components/consol/FSTopBar";

import swal from "sweetalert";
import {
  deletePopulateFSApiHandler,
  getConsolPrePopulateFSDetailsApiHandler,
  updatePopulateFSApiHandler,
} from "../../../WorkSpace/Components/ApiServices/apiHandler";
import { motion } from "framer-motion";
import commoncss from "../../css/common.module.css";
import bookclosurecss from "../../css/bookclosure.module.css";
import QuillReactEditor from "../../components/QuillReactEditor";
import ConsolFSTable from "./ConsolFSTable";
import InterCompanyEliminationsEntries from "../../components/console/InterCompanyEliminationEntires";
import BSPLTable from "../../../Console/Component/CustomTable/BSPLTable";
import ConsoleTable from "../../../Console/Component/CustomTable/ConsoleTable";
import ICEWorkings from "../../components/console/ICEWorkings";
import PerformReconciliation from "../../components/console/PerformReconciliation";
import ViewReconciliation from "../../components/console/ViewReconciliation";
import AdjAutoPopulatedEntries from "../../components/console/AdjAutoPopulatedEntries";
import ManualAdjustments from "../../components/console/ManualAdjustments";
import sidemenucss from "../../css/sidemenu.module.css";
import { useLocation } from "react-router-dom";

const ConsolPrePopulateFS = () => {
  const { consolID } = useParams();

  const history = useHistory();
  const dispatch = useDispatch();

  const [activeCat, setActiveCat] = useState("BS");
  const [isNotes, setIsNotes] = useState(false);
  const [loadData, setLoadData] = useState([]);
  const [notesId, setNotesId] = useState(null);
  const [redirectNote, setRedirectNote] = useState(null);
  const [subMenuId, setSubMenuId] = useState(null);
  const [subgroupId, setSubGroupId] = useState(null);
  const [columns, setColumns] = useState([]);
  const [subMenu, setSubMenu] = useState(null);
  const [bsPlData, setBsPlData] = useState(null);
  const [consoleData, setConsoleData] = useState(null);
  const [rows, setRows] = useState([]);
  const [notesData, setNotesData] = useState(null);
  const [updateTrigger, setUpdateTrigger] = useState(0);
  const [adjSubMenu, setAdjSubMenu] = useState("Auto populated entries");
  const [socieData, setSocieData] = useState(null);
  const [eliminationScreen, setEliminationScreen] = useState(0);
  const [selectedConsolName, setSelectedConsolName] = useState("");
  const [selectedReconciliationRow, setSelectedReconciliationRow] = useState(null);
  const location = useLocation();
  const formatIndianNumber = (val) => {
  if (val == null) return "";
  const num = Number(val);
  if (isNaN(num)) return String(val);

  if (num < 0) {
    return "(" + (-1 * num).toLocaleString("en-IN") + ")";
  }
  return num.toLocaleString("en-IN");
};
  const eliminationScreens = {
    0: "entries",
    1: "workings",
    2: "performreconciliation",
    3: "viewreconciliation",
  }

  useEffect(() => {
    if (location.state?.consolName) {
      setSelectedConsolName(location.state.consolName);
    }
  }, []);

  useEffect(() => {
    if ((activeCat === "BS") || (activeCat === "PL")) {
      const result = transformData(loadData ?? []);
      setRows(result ?? []);
    } else {

      setRows(loadData ?? []);
    }
  }, [loadData]);


  useEffect(() => {
    setColumns([]);

    if (activeCat !== "Adjustments") {

      setColumns([]);

      // BS / PL
      if (activeCat === "BS" || activeCat === "PL") {
        setIsNotes(false);
        setSubMenu(null);
        setColumns([
          {
            label: "Particular",
            field: "particular",
            align: "left",
            editable: false,
          },
          {
            label: "Notes",
            field: "notes",
            align: "left",
            editable: false,
            type: "redirect",
          },
          {
            label: "Current Year",
            field: "currentYear",
            align: "right",
            editable: false,
            type: "number",
          },
          {
            label: "Previous Year",
            field: "previousYear",
            align: "right",
            editable: false,
            type: "number",
          },
          {
            label: "References",
            field: "references",
            align: "left",
            editable: false,
            type: "array",
          },
        ]);
        return;
      }

      // SOCIE / Cashflow / Disclosure
      if (["socie", "cashflow", "disclosure"].includes(activeCat)) {
        setIsNotes(false);
        setSubMenu(null);

        if (rows.length > 0) {
          const catRows = Object.keys(rows[0] || {});
          const tableCols = catRows
            .filter(
              (item) =>
                item !== "_id" && item !== "lineType" && item !== "references"
            )
            .map((item) => ({
              label: item,
              field: item,
              align: "left",
              editable: false,
              type: "text",
            }));

          setColumns(tableCols);
        }
        return;
      }

      // Notes categories
      if (
        ["general notes", "BS notes", "PL notes", "disclosure", "checklist"].includes(activeCat)
      ) {
        setIsNotes(true);
        const submenuArray = rows.map((item) => ({
          label: item.particular,
          value: item._id,
          subGroup: item.subgroup,
        }));
        setSubMenu({
          category: activeCat,
          submenu: submenuArray,
        });
        setColumns([]);
        return;
      }

      setIsNotes(false);
      setSubMenu(null);
      setColumns([]);
    }
    setIsNotes(false);
    setSubMenu(null);
    setColumns([]);
  }, [activeCat, rows]);

  useEffect(() => {

    if (!isNotes) return;
    if (!subMenu?.submenu?.length) return;

    if (subMenuId) return;
    if (activeCat !== "Adjustments") {

      const first = subMenu.submenu[0];
      setSubMenuId(first.value);
    }
  }, [isNotes, activeCat, subMenu, subMenuId]);

  const handleRowsChange = (updatedRows) => {
    // console.log("updatedRows", updatedRows);
    // If you want local update from ConsolFSTable:
    // setRows(updatedRows);
  };

  const menuItems = [
    { label: "Balance Sheet", value: "BS" },
    { label: "P&L Statement", value: "PL" },
    { label: "General Notes", value: "general notes" },
    { label: "CashFlow", value: "cashflow" },
    { label: "SOCIE", value: "socie" },
    { label: "Balance Sheet Notes", value: "BS notes" },
    { label: "P&L Statement Notes", value: "PL notes" },
    { label: "Adjustments", value: "Adjustments" },
    { label: "Disclosures", value: "disclosure" },
    { label: "Disclosures Checklist", value: "checklist" },
  ];

  const adjustmentsMenuItems = [
    { label: "Auto populated entries", value: "Auto populated entries" },
    { label: "Manual adjustments", value: "Manual adjustments" },
    { label: "Inter company elimination", value: "Inter company elimination" }
  ];

  const getPopulateFS = (cat) => {
    const getParams = {
      category: cat,
      consolID: consolID,
    };
    getConsolPrePopulateFSDetailsApiHandler(getParams)
      .then((response) => {

        if (response?.data?.success === true) {
          const catData = response?.data?.data;
          if (cat === "BS" || cat === "PL") {
            setBsPlData(catData);
          }
          if (cat === "cashflow") {
            setConsoleData(catData);
          }
          if (cat === "socie") {
            setSocieData(catData);
          }
          if (cat === "BS notes" || cat === "PL notes" || cat === "disclosure") {
            setLoadData(catData);
          }
          if (cat === "general notes" || cat === "checklist") {
            setLoadData(catData);
          }
        }
        else {
          setLoadData([]);
          swal(
            "Error",
            response?.data?.error || "Unable to get FS the data",
            "error"
          );
        }
      })
      .catch((error) => {
        setLoadData([]);
        swal(
          "Error",
          error?.response?.data?.error || "Unable to Populate FS the data",
          "error"
        );
      });
  };

  useEffect(() => {
    setColumns([]);
    setSubMenu(null);
    setIsNotes(false);
    setNotesData(null);
    setSubGroupId(null);
    setSubMenuId(null);
    if (activeCat !== "Adjustments") {
      getPopulateFS(activeCat);
    }
  }, [activeCat]);

  const debounceTimer = useRef(null);

  const handleTableEdit = ({ _id, key, value, type = "table", tableId }) => {
    const params = {
      category: activeCat,
      consolID: consolID,
    };

    if (isNotes && type !== "text") {
      params["groupID"] = subMenuId;
      if (activeCat === "checklist") {
        params["subgroupID"] = _id;
      } else {
        params["subgroupID"] = tableId;
        params["rowID"] = _id;
      }
    } else {
      if (
        activeCat === "BS" ||
        activeCat === "PL" ||
        activeCat === "socie" ||
        activeCat === "cashflow" ||
        activeCat === "disclosure"
      ) {
        params["groupID"] = _id;
      }
    }

    const payload = {};

    if (isNotes && type === "text") {
      params["groupID"] = subMenuId;
      params["subgroupID"] = _id;

      payload["textRaw"] = key; // html
      payload["textPlain"] = value; // plaintext
    } else {
      payload[key] = value;
    }


    updatePopulateFSApiHandler(params, payload)
      .then((response) => {
        if (response?.data?.success === true) {

          if (isNotes) {
            if (type === "text") {
              setRows((prev) =>
                prev.map((group) => {
                  if (group._id !== subMenuId) return group;
                  return {
                    ...group,
                    subgroup: (group.subgroup || group.subGroup || []).map(
                      (sg) => {
                        if (sg._id !== _id) return sg;
                        return {
                          ...sg,
                          textRaw: payload.textRaw,
                          textPlain: payload.textPlain,
                        };
                      }
                    ),
                  };
                })
              );
            } else {
              setRows((prev) =>
                prev.map((group) => {
                  if (group._id !== subMenuId) return group;
                  return {
                    ...group,
                    subgroup: (group.subgroup || group.subGroup || []).map(
                      (sg) => {
                        if (sg._id !== subgroupId) return sg;
                        return {
                          ...sg,
                          table: (sg.table || []).map((row) =>
                            row._id === _id ? { ...row, [key]: value } : row
                          ),
                        };
                      }
                    ),
                  };
                })
              );
            }
          } else {
            // Non-notes tables (BS, PL, etc.)
            setRows((prev) =>
              prev.map((row) =>
                row._id === _id ? { ...row, [key]: value } : row
              )
            );
          }
        } else {
          swal(
            "Error",
            response?.data?.error || "Unable to update the data",
            "error"
          );
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to save the data",
          "error"
        );
      });
  };

  const handleTableEditDebounced = (args) => {
    clearTimeout(debounceTimer.current);

    debounceTimer.current = setTimeout(() => {

      handleTableEdit(args);
    }, 2000);
  };

  useEffect(() => {
    return () => clearTimeout(debounceTimer.current);
  }, []);

  

  const ShowChecklist = ({ subMenuId }) => {
    if (!subMenu) return null;

    const selNote = subMenu.submenu.find((item) => item.value === subMenuId);
    const rows = selNote?.subGroup || [];

    const checklistColumns = [
      {
        label: "Paragraph reference",
        field: "reference",
        align: "left",
        editable: false,
        type: "popup",
      },
      {
        label: "Disclosure",
        field: "notes",
        align: "left",
        maxWidth: 200,
        editable: false,
        type: "text",
      },
      {
        label: "Yes",
        field: "value",
        optionValue: "Y",
        align: "center",
        editable: false,
        type: "checkbox",
      },
      {
        label: "No",
        field: "value",
        optionValue: "N",
        align: "center",
        editable: false,
        type: "checkbox",
      },
      {
        label: "NA",
        field: "value",
        optionValue: "NA",
        align: "center",
        editable: false,
        type: "checkbox",
      },
      {
        label: "Remarks",
        field: "remark",
        align: "left",
        editable: false,
        type: "text",
      },
    ];

    return (
      <>
        <ConsolFSTable
          columns={checklistColumns}
          rows={rows}
          redirectTo={redirectTo}
        />
      </>
    );
  };

  const getPopulateFSNotes = async (cat) => {
    try {
      const getParams = {
        category: cat,
        consolID: consolID,
      };

      const response = await getConsolPrePopulateFSDetailsApiHandler(getParams);

      if (response?.data?.success === true) {
        return response.data.data;
      }

      return [];
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const redirectTo = async (arg) => {

    let subNotesCat = null;

    if (activeCat === "BS") {
      setActiveCat("BS notes");
      subNotesCat = "BS notes";
    }
    if (activeCat === "PL") {
      setActiveCat("PL notes");
      subNotesCat = "PL notes";
    }

    if (subNotesCat) {
      const data = await getPopulateFSNotes(subNotesCat);
      const resultId = data.find((item) => item.notes === arg)?._id;
      setRedirectNote(resultId || null);
    }
  };

  useEffect(() => {
    setEliminationScreen(0);
    setAdjSubMenu("Auto populated entries");
    if (!isNotes || activeCat === "checklist" || !subMenuId) {
      setNotesData(null);
      return;
    }
    if (activeCat !== "Adjustments") {
      if (!isNotes || activeCat === "checklist" || !subMenuId) {
        setNotesData(null);
        return;
      }
      const selNote = rows.find((item) => item._id === subMenuId) || null;
      setNotesData(selNote);
    }
  }, [isNotes, activeCat, subMenuId, rows]);

  useEffect(() => {
    if (!isNotes || activeCat === "checklist" || !notesData) return;

    if (activeCat !== "Adjustments") {

      if (!isNotes || activeCat === "checklist" || !notesData) return;

      const subGroups = notesData.subgroup || notesData.subGroup || [];
      const firstTableSg = subGroups.find(
        (sg) => (sg?.dataType ?? sg?.datatype) === "table"
      );

      setSubGroupId(firstTableSg?._id ?? null);
    }
  }, [isNotes, activeCat, notesData]);

  const showNotesDetails = (noteId) => {
    setSubMenuId(noteId);
  };

  const deletePopulateFS = async (subgroupID) => {
    try {
      const getParams = {
        category: activeCat,
        consolID: consolID,
        groupID: subMenuId,
        subgroupID: subgroupID
      };

      const response = await deletePopulateFSApiHandler(getParams);

      setUpdateTrigger((prev) => prev + 1);
      const delEl = document.getElementById(subgroupID)
      if (delEl) delEl.style.display = "none"
      return [];
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  useEffect(() => {
    if (!isNotes || activeCat === "checklist" || !subMenuId) {
      setNotesData(null);
      return;
    }
    if (activeCat !== "Adjustments") {

      if (!isNotes || activeCat === "checklist" || !subMenuId) {
        setNotesData(null);
        return;
      }

      const selNote = rows.find((item) => item._id === subMenuId) || null;
      setNotesData(selNote);
    }
  }, [updateTrigger]);

  const renderSubGroups = (notesData) => {

    const subGroups = notesData?.subgroup || notesData?.subGroup || [];

    return subGroups.map((sg, idx) => {
      const type = sg?.dataType ?? sg?.datatype ?? "";

      //  TABLE 
      if (type === "table") {
        const tableItems = Array.isArray(sg.table) ? sg.table : [];

        if (tableItems.length === 0) {
          return (
            <div key={`table-empty-${idx}`} className="mb-4">
              <small>No table data available</small>
            </div>
          );
        }

        // const catRows = Object.keys(tableItems[0] || {});
        // const tableCols = catRows
        //   .filter((col) => col !== "_id")
        //   .map((col) => {
          const rawCols = Object.keys(tableItems[0] || {}).filter(
            (col) => col !== "_id"
          );

          const normalCols = rawCols.filter((col) => col !== "references");

          const orderedCols = rawCols.includes("references")
            ? [...normalCols, "references"]
            : normalCols;

          const tableCols = orderedCols.map((col) => {
            if (col === "references") {
              return {
                label: col,
                field: col,
                align: "left",
                editable: false,
                type: "checklistref",
              };
            }
            return {
              label: col,
              field: col,
              align: "left",
              editable: false,
              type: "text",
            };
          });

        return (
          <React.Fragment key={`table-${idx}`}>
            <ConsoleTable tableData={tableItems}
             tableTitle={sg?.tableTitle} 
             type={activeCat}
             />

            {/* <ConsolFSTable
              columns={tableCols}
              rows={tableItems}
              onRowsChange={handleRowsChange}
              onCellChangeImmediate={handleTableEditDebounced}
              redirectTo={redirectTo}
              tableTitle={sg?.tableTitle}
              tableId={sg?._id}
              tableType={sg?.tableType}
              deletePopulateFS={deletePopulateFS}
            /> */}
          </React.Fragment>
        );
      }

      //  TEXT 
      if (type === "text") {
        return (
          <div className="mt-5" key={`text-${idx}`}>
            <QuillReactEditor
              value={sg?.textRaw ?? ""}
              onChange={(content) => {
                // handleTableEdit({
                //   _id: sg?._id,
                //   key: content.html,
                //   value: content.text,
                //   type: "text",
                // });
              }}
            />
          </div>
        );
      }

      //  FALLBACK 
      return <div key={`empty-${idx}`} />;
    });
  };


  const renderSocie = (socieData) => {
    // const subGroups = socieData?.table || socieData?.subGroup || [];

    return socieData.map((sg, idx) => {
      const type = "table";

      //  TABLE 
      if (type === "table") {
       const tableItems = (Array.isArray(sg.table) ? sg.table : []).map((row) => {
  const newRow = { ...row };

  Object.keys(newRow).forEach((key) => {
    if (
      key !== "_id" &&
      key !== "particular" &&
      key !== "references" &&
      newRow[key] !== null &&
      newRow[key] !== undefined &&
      !isNaN(newRow[key])
    ) {
      newRow[key] = formatIndianNumber(newRow[key]);
    }
  });

  return newRow;
});
        if (tableItems.length === 0) {
          return (
            <div key={`table-empty-${idx}`} className="mb-4">
              <small>No table data available</small>
            </div>
          );
        }

        const rawCols = Object.keys(tableItems[0] || {}).filter(
          (col) => col !== "_id" && col !== "lineType"
        );

        const normalCols = rawCols.filter(
          (col) => col !== "references" && col !== "particular"
        );

        const orderedCols = [
          "particular",
          ...normalCols,
          ...(rawCols.includes("references") ? ["references"] : []),
        ];
      const tableCols = orderedCols.map((col) => {
        
        
        // const tableCols = catRows
        //   .filter((col) => col !== "_id")
        //   .filter((col) => col !== "lineType")
        //   .map((col) => {
        //     if (col === "references") {
        // if (col === "references") {
        //       return {
        //         label: col,
        //         field: col,
        //         align: "left",
        //         editable: false,
        //         type: "checklistref",
        //         width: 270,
        //         minWidth: 270,
        //         maxWidth: 270
        //       };
        //     }
        //     return {
        //       label: col,
        //       field: col,
        //       align: "left",
        //       editable: false,
        //       type: "text",
        //        width: 270,
        //     };
        //   });

         if (col === "particular") {
          return {
            label: col,
            field: col,
            align: "left",
            editable: false,
            type: "text",
            width: 340,
            minWidth: 310,
            maxWidth: 300,
            sticky: true,
          };
        }

        if (col === "references") {
          return {
            label: col,
            field: col,
            align: "left",
            editable: false,
            type: "checklistref",
            width: 300,
            minWidth: 300,
            maxWidth: 300,
          };
        }

        return {
          label: col,
          field: col,
          align: "right",
          editable: false,
          type: "text",
          width: 300,
          minWidth: 300,
          maxWidth: 300,
        };
      });

        return (
          <React.Fragment key={`table-${idx}`}>
            <ConsolFSTable
              columns={tableCols}
              rows={tableItems}
              // onRowsChange={handleRowsChange}
              // onCellChangeImmediate={handleTableEditDebounced}
              redirectTo={redirectTo}
              tableTitle={sg?.title}
              tableId={sg?._id}
              tableType={sg?.tableType}
              deletePopulateFS={deletePopulateFS}
            />
          </React.Fragment>
        );
      }

      //  TEXT 
      if (type === "text") {
        return (
          <div className="mt-5" key={`text-${idx}`}>
            <QuillReactEditor
              value={sg?.textRaw ?? ""}
              onChange={(content) => {
                // handleTableEdit({
                //   _id: sg?._id,
                //   key: content.html,
                //   value: content.text,
                //   type: "text",
                // });
              }}
            />
          </div>
        );
      }

      //  FALLBACK 
      return <div key={`empty-${idx}`} />;
    });

  };

  const transformData = (data) => {
    const output = [];

    const walk = (node) => {
      if (node.level === 3) return;
      // level 1 => header, others => row
      const type = node.level === 1 ? "header" : "row";

      output.push({
        _id: node._id,
        lineType: type,
        particular: node.name,
        notes: node.notes ?? null,
        currentYear: node.currentYear ?? null,
        previousYear: node.previousYear ?? null,
        references: node.references ?? []
      });

      if (node.subgroup && node.subgroup.length) {
        node.subgroup.forEach(walk);
      }
    };

    data.forEach(walk);
    return output;
  };

  const tableData = [
    {
      "_id": "692a3004b4151927e49bb7dd",
      "category": "BS",
      "lineType": "line item",
      "name": "Non-current assets",
      "level": 1,
      "nature": "debit",
      "subgroup": [
        {
          "references": [1, 3],
          "_id": "692a3004b4151927e49bb7de",
          "lineType": "line item",
          "name": "Property, Plant & Equipment",
          "level": 2,
          "subgroup": [
            {
              "references": [],
              "_id": "692a3004b4151927e49bb7df",
              "lineType": "line item",
              "name": "Land - Gross block",
              "level": 3,
              "formula": [],
              "companies": [
                {
                  "title": "Company A",
                  "currentYear": 2000,
                  "previousYear": 1000
                },
                {
                  "title": "Company B",
                  "currentYear": 3000,
                  "previousYear": 2000
                },
                {
                  "title": "Adjustments",
                  "currentYear": 500,
                  "previousYear": 1000
                },
                {
                  "title": "Total",
                  "currentYear": 5500,
                  "previousYear": 4000
                }
              ]
            }
          ],
          "formula": [],
          "notes": 3,
          "companies": [
            {
              "title": "Company A",
              "currentYear": 2000,
              "previousYear": 1000
            },
            {
              "title": "Company B",
              "currentYear": 3000,
              "previousYear": 2000
            },
            {
              "title": "Adjustments",
              "currentYear": 500,
              "previousYear": 1000
            },
            {
              "title": "Total",
              "currentYear": 5500,
              "previousYear": 4000
            }
          ]
        }
      ],
      "formula": []
    }
  ]

  const notesSample = [
    {
      "_id": "6953a4b5d73b643b49e71242",
      "particular": "Property, Plant & Equipment",
      "subgroup": [
        {
          "_id": "6953a4b5d73b643b49e71243",
          "dataType": "table",
          "tableTitle": "Property, Plant & Equipment",
          "table": [
            {
              "references": [],
              "_id": "6953a4b5d73b643b49e71244",
              "particular": "Land - Gross block",
              "companies": [
                {
                  "title": "Company A",
                  "currentYear": 2000,
                  "previousYear": 1000
                },
                {
                  "title": "Company B",
                  "currentYear": 3000,
                  "previousYear": 2000
                },
                {
                  "title": "Adjustments",
                  "currentYear": 500,
                  "previousYear": 1000
                },
                {
                  "title": "Total",
                  "currentYear": 5500,
                  "previousYear": 4000
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "_id": "6953a4b5d73b643b49e71232",
      "particular": "Other Intangible Assets",
      "subgroup": [
        {
          "_id": "6953a4b5d73b643b49e71233",
          "dataType": "table",
          "tableTitle": "Other Intangible Assets",
          "table": [
            {
              "references": [],
              "_id": "6953a4b5d73b643b49e71234",
              "particular": "Brands/trademarks",
              "companies": [
                {
                  "title": "Company A",
                  "currentYear": 2000,
                  "previousYear": 1000
                },
                {
                  "title": "Company B",
                  "currentYear": 3000,
                  "previousYear": 2000
                },
                {
                  "title": "Adjustments",
                  "currentYear": 500,
                  "previousYear": 1000
                },
                {
                  "title": "Total",
                  "currentYear": 5500,
                  "previousYear": 4000
                }
              ]
            }
          ]
        }
      ]
    }
  ]
  return (
    <>
      <div className={`${workSpaceCss.df}`}>
        <div className={`d-flex ${commoncss.pageContent}`}>
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 100, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            <FSSideMenu
              title="Consol FS"
              titleClassName={sidemenucss.customTitle}
              subTitle={selectedConsolName} 
              menuItems={menuItems}
              subMenu={subMenu}
              activeCat={activeCat}
              setActiveCat={setActiveCat}
              setSubMenuId={setSubMenuId}
              showNotesDetails={showNotesDetails}
              redirectNote={redirectNote}
              setRedirectNote={setRedirectNote}
              subMenuId={subMenuId}
              adjustmentsMenuItems={adjustmentsMenuItems}
              adjSubMenu={adjSubMenu}
              setAdjSubMenu={setAdjSubMenu}
            />
          </motion.div>
          <div
            className={bookclosurecss.bookClosureContent}
            style={{ width: "85.5vw", overflow: "hidden" }}
          >
            {activeCat !== "Adjustments" &&
              <div className={`${bookclosurecss.bookClosureHeader} p-0`}>
                <FSTopBar history={history} consolID={consolID} prepopulate={true} />
              </div>
            }

            <div
              style={{
                height:
                activeCat === "Adjustments" ||
                activeCat === "BS notes" ||
                activeCat === "PL notes"
                  ? "auto"
                  : "88vh",
                //overflow: "auto",
                padding: ["general notes", "cashflow", "socie","BS notes","PL notes"].includes(activeCat) ? "10px 45px 0px 25px" : "0px 25px 0 25px",
               // padding: ["PL"].includes(activeCat) ? "0px 25px 0px 25px" : "0px 27px 0 25px",
              }}
            >
              {/* <BSPLTable tableData={tableData} /> */}
              {!isNotes && activeCat !== "checklist" && (activeCat === "BS" || activeCat === "PL") && (
                <div className="bs-pl-notes-wrapper">
                  <BSPLTable tableData={bsPlData} redirectTo={redirectTo} />
                </div>
              )}
 
              {!isNotes && activeCat !== "checklist" && (activeCat === "cashflow") && <ConsoleTable tableData={consoleData} />}

              {!isNotes && activeCat !== "checklist" && socieData && (activeCat === "socie") && (<div className="socie-scroll-wrapper"> {renderSocie(socieData)}</div>)}


              {isNotes && notesData && activeCat !== "checklist" && activeCat !== "Adjustments" && (
                <div className={ activeCat === "BS notes" || activeCat === "PL notes" ? "bs-pl-notes-wrapper" : "" }>
                  {
                    renderSubGroups(notesData)
                  }
                </div>
              )}

              {isNotes && subMenuId && activeCat === "checklist" && activeCat !== "Adjustments" && (
                <ShowChecklist subMenuId={subMenuId} />
              )}
              {activeCat === "Adjustments" && adjSubMenu === "Auto populated entries" && (
                <AdjAutoPopulatedEntries
                  history={history}
                  consolID={consolID} />
              )}
              {activeCat === "Adjustments" && adjSubMenu === "Manual adjustments" && (
                <ManualAdjustments
                  history={history}
                  consolID={consolID} />
              )}
              {activeCat === "Adjustments" && adjSubMenu === "Inter company elimination" && (
                <>
                  {eliminationScreens[eliminationScreen] === "entries" && (
                    <InterCompanyEliminationsEntries
                      setEliminationScreen={setEliminationScreen}
                      history={history}
                      consolID={consolID}
                    />
                  )}

                  {eliminationScreens[eliminationScreen] === "workings" && (
                    <ICEWorkings setEliminationScreen={setEliminationScreen}
                      consolID={consolID}
                    />
                  )}

                  {eliminationScreens[eliminationScreen] === "performreconciliation" && (
                    <PerformReconciliation setEliminationScreen={setEliminationScreen}
                      consolID={consolID}
                      setSelectedReconciliationRow={setSelectedReconciliationRow}
                    />
                  )}

                  {eliminationScreens[eliminationScreen] === "viewreconciliation" && (
                    <ViewReconciliation setEliminationScreen={setEliminationScreen}
                      consolID={consolID}
                      configIndex={selectedReconciliationRow?.configIndex}
                      parentCompanyID={selectedReconciliationRow?.parentCompanyID}
                      subsidiaryCompanyID={selectedReconciliationRow?.subsidiaryCompanyID}
                    />
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConsolPrePopulateFS;
